import script from "./Internet5gOfferCard.vue?vue&type=script&setup=true&lang=js"
export * from "./Internet5gOfferCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__